import UserDTO from 'Js/api/v1/DTO/UserDTO';
import ajax from 'Js/api/lib/ajax';

/**
 * Пользователь АвтоПро
 */
export default class User extends UserDTO {
    /**
     * @param {string} login
     * @param {Object} [profile]
     */
    constructor(login, profile) {
        super(profile || {});

        this.login = login;

        // TODO: если эти поля будут передаваться через API, перенести их в UserDTO
        if (profile) {
            this.isLimited = Boolean(profile.isLimited);
            this.isBlocked = Boolean(profile.isBlocked);
            this.isGtdWhBlocked = Boolean(profile.isGtdWhBlocked);
            this.dialoguesCount = profile.dialoguesCount
                ? parseInt(profile.dialoguesCount, 10)
                : 0;
            // new
            this.sellerCountry = profile.sellerCountry || '';
            this.becomeSellerDate = profile.becomeSellerDate;
        }
    }

    static parse(DTO) {
        if (DTO && typeof DTO == 'object') {
            return new User(null, DTO);
        }
        return null;
    }

    /**
     * Аутентификация пользователя
     * @param {string} login
     * @param {string} password
     * @returns {Promise}
     */
    static signIn(login, password) {
        return ajax.post({
            url: '/api/v1/account/sign-in',
            data: {
                Login: login,
                Password: password
            },
            dataType: 'json'
        });
    }

    /**
     * Регистрация нового пользователя
     * @param {string} login
     * @param {string} password
     * @param {string} [returnUrl]
     * @returns {Promise}
     */
    static signUp(login, password, returnUrl = '/confirm-email/') {
        return ajax.post({
            url: '/api/v1/account/sign-up',
            data: {
                Login: login,
                Password: password,
                ReturnUrl: returnUrl
            },
            dataType: 'json'
        });
    }

    /**
     * Регистрация юзера по почте, телефону и сифниф
     * @param {string} login
     * @param {string} phone
     * @param {string} cifNif
     * @param {string} returnUrl
     */
    static async signUpAsAutoservice(login, phone, taxNumber, returnUrl) {
        try {
            const data = {
                Login: login,
                Phone: phone,
                TaxNumber: taxNumber,
                ReturnUrl: returnUrl
            };

            const response = await fetch(
                '/api/v1/account/sign-up-as-autoservice',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data)
                }
            );

            const contentType = response.headers.get('content-type');

            // TODO рефакторинг бекенда
            const value =
                contentType && contentType.includes('application/json')
                    ? await response.json()
                    : await response.text();
            return {
                ok: response.ok,
                status: response.status,
                data: await value
            };
        } catch (error) {
            console.error('Network error in sign up autoservice:', error);
            return {
                ok: false
            };
        }
    }

    /**
     * Войти под другим пользователем (для админа),
     * или переключиться обратно на своего пользователя.
     * Опция switchBack нужна для возможности логина под следующими userId
     * без передварительного выхода из предыдущих (эта операция будет выполняться неявно)
     * @param {number} [userId]
     * @param {boolean} [switchBack]
     */
    static switchUser(userId, switchBack = false) {
        if (userId && switchBack) {
            return User.switchUser(0).then(() =>
                User.switchUser(userId, false)
            );
        } else if (userId)
            return ajax.post({
                url: '/api/v1/account/switch-user',
                data: {
                    userId
                }
            });
        else
            return ajax.post({
                url: '/api/v1/account/switch-user-back'
            });
    }

    /**
     * Загрузка личных данных пользователя
     */
    static getProfile() {
        return ajax.get({
            url: '/api/v1/account/personal-data',
            contentType: 'application/json',
            dataType: 'json',
            settings: {
                withCredentials: true
            },
            process: profile => new UserDTO(profile)
        });
    }
    /**
     * Загрузка данных пользователя IsBuyer IsGuest IsSeller IsVerified Phone
     */

    static getDataUser() {
        return ajax.get({
            url: '/api/v1/account/eshop-phone',
            contentType: 'application/json',
            dataType: 'json',
            settings: {
                withCredentials: true
            }
        });
    }

    /**
     * Редактирование личных данных пользователя
     * @param {Object} profile
     * @param {File} [logo]
     */
    static postProfile(profile, logo) {
        const formData = new FormData();
        const jsonData = UserDTO.prototype.toJSON.call(profile);

        formData.append('userProfileData', JSON.stringify(jsonData));

        if (logo instanceof File) {
            formData.append('file', logo);
        }

        return ajax.post({
            url: '/api/v1/personal-data',
            dataType: 'json',
            data: formData,
            settings: {
                withCredentials: true
            }
        });
    }

    /**
     * Удаление аватара пользователя (логотипа компании)
     */
    static deleteLogo() {
        return ajax.delete({
            url: '/api/v1/personal-data/logotip'
        });
    }

    /**
     * Ability configuration
     * @see https://casl.js.org/v5/en/guide/subject-type-detection
     */
    static get modelName() {
        return 'User';
    }
}
